var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-details-wangluo"},[_c('div',{staticClass:"pie-wrap"},[_c('div',{ref:"left",staticClass:"pie-left"},[_vm._v(" left ")]),_c('div',{staticClass:"pie-right"},[_c('div',{ref:"top",staticClass:"pie-right-top"},[_vm._v("top")]),_c('div',{ref:"bottom",staticClass:"pie-right-bottom"},[_vm._v("bottom")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }